import type { AppState, Category, CalendarDef, IconId, Settings } from './model.ts';
import { SCHEMA_VERSION } from './model.ts';
import { DEFAULT_TIME_ZONE } from './time.ts';

export const BUILTIN_CATEGORIES: Category[] = [
  { id: 'privat', name: 'Privat', icon: 'home', builtIn: true },
  { id: 'arbete', name: 'Arbete', icon: 'briefcase', builtIn: true },
  { id: 'halsa', name: 'Hälsa', icon: 'hospital', builtIn: true, sensitive: true },
  { id: 'myndighet', name: 'Myndighet', icon: 'landmark', builtIn: true, sensitive: true },
  { id: 'ekonomi', name: 'Ekonomi', icon: 'receipt', builtIn: true, sensitive: true },
  { id: 'traning', name: 'Träning', icon: 'dumbbell', builtIn: true },
  { id: 'resa', name: 'Resa', icon: 'plane', builtIn: true },
  { id: 'annat', name: 'Annat', icon: 'star', builtIn: true },
];

export const MAX_CUSTOM_CATEGORIES = 12;

/** Ikoner användaren kan välja. Texten används som tillgänglig etikett. */
export const ICON_LABELS: Record<IconId, string> = {
  home: 'Hem',
  briefcase: 'Portfölj',
  hospital: 'Sjukhus',
  stethoscope: 'Läkare',
  building: 'Byggnad',
  landmark: 'Myndighet',
  receipt: 'Kvitto',
  wallet: 'Plånbok',
  dumbbell: 'Hantel',
  plane: 'Flyg',
  car: 'Bil',
  calendar: 'Kalender',
  star: 'Stjärna',
  book: 'Bok',
  users: 'Personer',
  utensils: 'Mat',
  pill: 'Medicin',
  baby: 'Barn',
  graduation: 'Utbildning',
  music: 'Musik',
  heart: 'Hjärta',
};

export const DEFAULT_CALENDARS: CalendarDef[] = [
  { id: 'cal-privat', name: 'Privat', kind: 'private', color: '#68D8C3', visible: true },
  { id: 'cal-arbete', name: 'Arbete', kind: 'work', color: '#8AB4F8', visible: true },
];

export const SKATTEFIX_SOURCE_ID = 'skattefix-ab';
export const SKATTEFIX_SOURCE_NAME = 'SkatteFix AB';
export const SKATTEFIX_CALENDAR: CalendarDef = {
  id: 'cal-skattefix',
  name: 'SkatteFix (importerad)',
  kind: 'import',
  color: '#E8B86B',
  visible: true,
  sourceId: SKATTEFIX_SOURCE_ID,
};

export const DEFAULT_SETTINGS: Settings = {
  timeZone: DEFAULT_TIME_ZONE,
  timeZoneConfirmed: false,
  locale: 'sv-SE',
  weekStartsOn: 1,
  quietHours: { enabled: false, start: '22:00', end: '07:00' },
  hideSensitiveOnLockScreen: true,
  defaultAlarmsMinutes: [-1440, -60, -15],
  maxSnoozesPerPoint: 5,
  summarizeImportedAllDay: true,
};

export function createInitialState(): AppState {
  return {
    schemaVersion: SCHEMA_VERSION,
    settings: { ...DEFAULT_SETTINGS, quietHours: { ...DEFAULT_SETTINGS.quietHours } },
    calendars: Object.fromEntries([...DEFAULT_CALENDARS, SKATTEFIX_CALENDAR].map((c) => [c.id, { ...c }])),
    categories: Object.fromEntries(BUILTIN_CATEGORIES.map((c) => [c.id, { ...c }])),
    events: {},
    sourceItems: {},
    overlays: {},
    sources: {},
    templates: {},
    appliedOps: {},
  };
}
